import {
  Box,
  Button,
  Paper,
  styled,
  TextField,
  Typography,
} from "@mui/material";
import { useForm } from "react-hook-form";
import DropDownList from "./dropdowmList/DropDownList";
import emailjs from "emailjs-com";

const StyledTextField = styled(TextField)({
  width: "100%",
  // Set the input field height
  "& .MuiOutlinedInput-root": {
    height: "5vh", // Set height to 5% of viewport height
    display: "flex",
    alignItems: "center", // Align text vertically
    "& fieldset": {
      border: "1px solid black",
    },
    "&.Mui-focused fieldset": {
      border: "2px solid #55d6aa", // Border color when focused
    },
  },

  // Style the input (text inside)
  "& .MuiOutlinedInput-input": {
    padding: "0 14px", // Adjust padding
    fontSize: "1rem", // Default text size
    "&::placeholder": {
      color: "gray", // Placeholder color
      fontSize: "0.9rem", // Placeholder font size
      opacity: 1, // Make sure placeholder is visible
    },
  },

  // Default Label Style
  "& .MuiInputLabel-root": {
    fontSize: "1rem", // Default label size
    top: "50%", // Align vertically
    transform: "translate(14px, -50%)", // Center label
    transition: "all 0.2s ease-in-out", // Smooth transition
  },

  // Focused Label Style
  "& .MuiInputLabel-root.Mui-focused, & .MuiInputLabel-shrink": {
    fontSize: "0.75rem", // Reduce size on focus
    transform: "translate(14px, -27px) scale(1)", // Move up
    fontWeight: "bold", // Make bold on focus
    color: "#242424", // Change color on focus
    transition: "all 0.2s ease-in-out", // Smooth animation
  },
});

const MultilinedTextField = styled(TextField)({
  width: "100%",
  // Set the input field height
  "& .MuiOutlinedInput-root": {
    display: "flex",
    alignItems: "center", // Align text vertically
    "& fieldset": {
      border: "1px solid black",
    },
    "&.Mui-focused fieldset": {
      border: "2px solid #55d6aa", // Border color when focused
    },
  },

  // Style the input (text inside)
  "& .MuiOutlinedInput-input": {
    // padding: "0 14px", // Adjust padding
    fontSize: "1rem", // Default text size
    "&::placeholder": {
      color: "gray", // Placeholder color
      fontSize: "0.9rem", // Placeholder font size
      opacity: 1, // Make sure placeholder is visible
    },
  },

  // Focused Label Style
  "& .MuiInputLabel-root.Mui-focused, & .MuiInputLabel-shrink": {
    fontSize: "0.75rem", // Reduce size on focus
    transform: "translate(14px, -10px) scale(1)", // Move up
    fontWeight: "bold", // Make bold on focus
    color: "#242424", // Change color on focus
    transition: "all 0.2s ease-in-out", // Smooth animation
  },
});

const Textfield = ({ label, register, error, helperText }) => {
  return (
    // <Textfield label={label} {...register} error={error} helperText={helperText} />

    <Box sx={{ height: "8vh" }}>
      <StyledTextField label={label} {...register} />
      {error && (
        <Typography sx={{ fontSize: "0.8rem", color: "red", ml: 1 }}>
          {error}
        </Typography>
      )}
      {helperText && (
        <Typography sx={{ fontSize: "0.8rem", color: "red", ml: 1 }}>
          {helperText}
        </Typography>
      )}
    </Box>
  );
};

const FormBox = styled(Box)(({theme}) => ({
  display: "grid",
  flexDirection: 'row',
  gridTemplateColumns: "auto auto",
  gap: 20,

  //mobile screen
  [theme.breakpoints.down('sm')]: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'start',
  }
}));

function ContactForm() {
  const {
    register,
    handleSubmit,
    formState: { errors },
    reset,
  } = useForm();

  const onSubmit = (data) => {
    console.log("Form Data:", data);

    const emailData = {
      user_name: `${data.firstName} ${data.lastName}`,
      user_email: data.email,
      user_phone: data.mobile,
      user_company: data.company,
      user_designation: data.designation,
      user_industry: data.industry,
      user_message: data.description,
    };

    emailjs
      .send(
        "service_kukzfwd",
        "template_qe4hs2w",
        emailData,
        "oiScglFqfosxx4XAJ"
      )
      .then((response) => {
        alert("Enquiry sent successfully!");
        reset(); // Reset form after submission
      })
      .catch((error) => {
        alert("Failed to send enquiry. Try again later.");
        console.error("EmailJS Error:", error);
      });
  };

  return (
    <Box
      component="form"
      onSubmit={handleSubmit(onSubmit)}
      sx={{ width: { md: '60%', xs: '95%' } }}
    >
      <Paper
        elevation={4}
        sx={{ width: "100%", py: 2 }}
      >
        <Box
          sx={{
            width: "100%",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            py: 2,
          }}
        >
          <Typography variant="h4" fontWeight={600} fontFamily={"sans-serif"} textAlign={'center'} sx={{ fontSize: { md: '2.1rem', xs: '1.8rem' } }} >
            Share Your Thoughts with Us!
          </Typography>
        </Box>

        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            width: "90%",
            gap: 2,
            ml: { md: 5, xs: 2 },
            justifyContent: "center",
          }}
        >
          <FormBox>
            <Textfield
              label="First Name*"
              register={register("firstName", {
                required: "First Name is required",
              })}
              error={!!errors.firstName}
              helperText={errors.firstName?.message}
            />
            <Textfield
              label="Last Name*"
              register={register("lastName", {
                required: "Last Name is required",
              })}
              error={!!errors.lastName}
              helperText={errors.lastName?.message}
            />
            <Textfield
              label="Email*"
              register={register("email", {
                required: "Email is required",
                pattern: {
                  value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
                  message: "Invalid email",
                },
              })}
              error={!!errors.email}
              helperText={errors.email?.message}
            />
            <Box sx={{ display: "flex", gap: 2 }}>
              <Box sx={{ width: "30%" }}>
                <DropDownList label="Code" check="1" />
              </Box>
              <Box sx={{ width: "70%" }}>
                <Textfield
                  label="Contact Number*"
                  register={register("mobile", {
                    required: "Mobile is required",
                    pattern: {
                      value: /^[0-9]{10}$/,
                      message: "Enter valid 10-digit number",
                    },
                  })}
                  error={!!errors.mobile}
                  helperText={errors.mobile?.message}
                />
              </Box>
            </Box>
            <Textfield
              label="Company Name*"
              register={register("company", {
                required: "Company Name is required",
              })}
              error={!!errors.company}
              helperText={errors.company?.message}
            />
            <Textfield label="Designation" register={register("designation")} />
            <DropDownList label="Select Country" check="2" />
            <Textfield label="Industry" register={register("industry")} />
          </FormBox>

          <MultilinedTextField
            label="Description"
            {...register("description", {
                required: "Messagee is required",
              })}
            fullWidth
            error={!!errors.description}
            helperText={errors.description?.message}
            multiline
            rows={4}
          />

          <Button
            type="submit"
            fullWidth
            variant="contained"
            sx={{ mt: 2, color: "#242424", bgcolor: '#55d6aa' }}
          >
            Submit
          </Button>
        </Box>
      </Paper>
    </Box>
  );
}

export default ContactForm;
